import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hot", label: "今日热评" },
  { href: "#barrage", label: "弹幕广场" },
  { href: "#memes", label: "表情包" },
  { href: "#jokes", label: "神梗段子" },
  { href: "#reactions", label: "网友反应" },
  { href: "#faq", label: "吃瓜小问" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div
        className={`transition-all duration-300 ${
          scrolled ? "bg-background-50/95 shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="container-page flex h-16 items-center justify-between">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-star-smile-line text-xl"></i>
            </span>
            <span className="heading-font text-xl text-foreground-950">
              明星吃瓜<span className="text-primary-500">·现场</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <a
              href="#contact"
              className="btn-ripple whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600"
            >
              我要投稿
              <i className="ri-send-plane-line"></i>
            </a>
          </div>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-foreground-800 md:hidden"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50/98 md:hidden">
          <nav className="container-page flex flex-col gap-1 py-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-ripple mt-2 rounded-full bg-primary-500 text-background-50 hover:bg-primary-600"
            >
              我要投稿
              <i className="ri-send-plane-line"></i>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}